import { apiClient } from '../client'

/**
 * Leaked data API endpoints
 */
export const leakedApi = {
  /**
   * Get leaked data list
   */
  getList: async (params?: string): Promise<any> => {
    const url = params ? `/leaked/?${params}` : '/leaked/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get leaked data by ID
   */
  getById: async (leakedId: string): Promise<any> => {
    const { data } = await apiClient.get(`/leaked/${leakedId}/`)
    return data
  },

  /**
   * Get leaked data statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/leaked/stats/')
    return data
  },

  /**
   * Get leaked data hosts (databases)
   */
  getHosts: async (page: number = 1, params: string): Promise<any> => {
    const url = params ? `/leaked-data/hosts/?${params}&page=${page}` : `/leaked-data/hosts/?page=${page}`
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get leaked data host details by ID
   */
  getHostById: async (hostId: string, page: number = 1): Promise<any> => {
    const { data } = await apiClient.get(`/leaked-data/hosts/${hostId}/?page=${page}`)
    return data
  },
}
